import {useCassandraLazyQuery} from '@possible/cassandra/src/utils/hooks'
import {UserDocument, UserDocumentStatus, UserDocumentSubType} from 'src/cassandra'
import {UserDlDocumentsDocument} from 'src/products/loans/IDScan/UserDLDocuments.gqls'

export const useGetValidDriverLicenses = (): {
  getDLDocuments: () => Promise<Partial<UserDocument>[]>
  isLoading: boolean
} => {
  const [runQuery, {loading: isLoading}] = useCassandraLazyQuery(UserDlDocumentsDocument)

  const getDLDocuments = async (): Promise<Partial<UserDocument>[]> => {
    const {data} = await runQuery()
    return (data?.me?.documents?.all ?? [])
      .filter(
        (doc) =>
          doc?.document?.subType === UserDocumentSubType.DriversLicenseFront &&
          doc?.document?.status === UserDocumentStatus.Verified,
      )
      .map((doc) => doc.document)
  }

  return {
    getDLDocuments,
    isLoading,
  }
}
